__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/8accc19/packs/";